import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import CompanyInfo from './components/CompanyInfo';
import AccessMap from './components/AccessMap';

const AboutPage = () => {
  useEffect(() => {
    document.title = '会社概要 - 岡山市北区の訪問介護サービス｜ヘルパーステーションおかやま';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'ヘルパーステーションおかやまの会社概要。岡山市北区で2020年設立。代表取締役 岡山太郎のもと、地域密着型の訪問介護サービスを提供しています。');
    }

    // Add Organization Schema
    const orgSchema = document.createElement('script');
    orgSchema.type = 'application/ld+json';
    orgSchema.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "おかやま訪問介護株式会社",
      "alternateName": "ヘルパーステーションおかやま",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://helper-station-okayama.example.com'}/about`,
      "logo": `${import.meta.env.VITE_SITE_URL || 'https://helper-station-okayama.example.com'}/vite.svg`,
      "foundingDate": "2020",
      "founder": {
        "@type": "Person",
        "name": "岡山太郎",
        "jobTitle": "代表取締役"
      },
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "○○町1-2-3",
        "addressLocality": "岡山市北区",
        "addressRegion": "岡山県",
        "postalCode": "700-0000",
        "addressCountry": "JP"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+81-86-012-3456",
        "contactType": "customer service",
        "areaServed": "JP",
        "availableLanguage": "Japanese"
      },
      "numberOfEmployees": 5
    });
    document.head.appendChild(orgSchema);

    return () => {
      if (orgSchema.parentNode) {
        orgSchema.parentNode.removeChild(orgSchema);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <AboutHero />
        <CompanyInfo />
        <AccessMap />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;